<template>
  <div class="interview-app">
    <div v-if="currentStep === 0" class="page-login">
      <div class="login-header">
        <img :src="logoSrc" class="logo" />
        <h2>面试签到</h2>
        <p>欢迎参加 {{ comName }} 面试</p>
      </div>

      <div class="login-box">
        <h3>请输入手机号完成签到</h3>
        <p class="subtitle">请输入投递简历上的手机号</p>

        <van-field maxlength="11" v-model="loginForm.phone" type="tel" label="+86" label-width="40px"
          placeholder="请输入手机号" class="phone-input" clearable />

        <van-button type="info" block round @click="goToNext" class="submit-btn">
          立即签到
        </van-button>

        <div class="policy">
          <van-checkbox v-model="loginForm.agree" shape="round" icon-size="14px">
            我已阅读并同意 <a href="#/policy" target="_blank">《隐私政策》</a>
          </van-checkbox>
        </div>
      </div>
      <div class="foot">由 智猎AI招聘 提供技术支持</div>
    </div>

    <div v-else-if="currentStep >= 1 && currentStep <= 5" class="page-steps">
      <van-steps :active="currentStep - 1" active-color="#1989fa" class="custom-steps">
        <van-step>基础信息</van-step>
        <van-step>工作经历</van-step>
        <van-step>教育经历</van-step>
        <van-step v-if="familySwitch">家庭信息</van-step>
        <van-step>声明</van-step>
      </van-steps>
      <div class="form-container">
        <div v-show="currentStep === 1">
          <h3 class="section-title">基础信息</h3>
          <van-form>
            <van-field v-model="formData.basic.channel" :required="baseInfoConfig[0] && baseInfoConfig[0].required"
              is-link readonly label="来源渠道" placeholder="请选择来源渠道" @click="showpicker('channel')"
              v-if="baseInfoConfig[0] && baseInfoConfig[0].show" />

            <van-field v-model="formData.basic.interviewJob" :required="baseInfoConfig[1] && baseInfoConfig[1].required"
              label="应聘岗位" placeholder="请输入应聘岗位" clearable v-if="baseInfoConfig[1] && baseInfoConfig[1].show" />

            <van-field v-model="formData.basic.name" :required="baseInfoConfig[2] && baseInfoConfig[2].required"
              label="姓名" placeholder="请输入您的姓名" clearable v-if="baseInfoConfig[2] && baseInfoConfig[2].show" />

            <van-field v-model="formData.basic.gender" :required="baseInfoConfig[3] && baseInfoConfig[3].required"
              is-link readonly label="性别" placeholder="请选择性别" @click="showpicker('gender')" clearable
              v-if="baseInfoConfig[3] && baseInfoConfig[3].show" />

            <van-field v-model="formData.basic.phone" :required="baseInfoConfig[4] && baseInfoConfig[4].required"
              maxlength="11" label="手机号码" placeholder="请输入手机号码" clearable
              v-if="baseInfoConfig[4] && baseInfoConfig[4].show" />

            <van-field v-model="formData.basic.email" :required="baseInfoConfig[5] && baseInfoConfig[5].required"
              label="邮箱" placeholder="请输入邮箱地址" clearable v-if="baseInfoConfig[5] && baseInfoConfig[5].show" />

            <van-field v-model="formData.basic.birthDate" :required="baseInfoConfig[6] && baseInfoConfig[6].required"
              label="出生年月" placeholder="请选择出生年月" readonly is-link @click="showpicker('birthDate')"
              v-if="baseInfoConfig[6] && baseInfoConfig[6].show" />

            <van-field v-model="formData.basic.nation" :required="baseInfoConfig[7] && baseInfoConfig[7].required"
              label="民族" placeholder="请选择民族" clearable v-if="baseInfoConfig[7] && baseInfoConfig[7].show" />

            <van-field v-model="formData.basic.origin" :required="baseInfoConfig[8] && baseInfoConfig[8].required"
              label="籍贯" placeholder="请输入籍贯" clearable v-if="baseInfoConfig[8] && baseInfoConfig[8].show" />

            <van-field v-model="formData.basic.household" :required="baseInfoConfig[9] && baseInfoConfig[9].required"
              label="户口" placeholder="请选择户口" readonly is-link @click="showpicker('household')"
              v-if="baseInfoConfig[9] && baseInfoConfig[9].show" />

            <van-field v-model="formData.basic.politics" :required="baseInfoConfig[10] && baseInfoConfig[10].required"
              label="政治面貌" placeholder="请选择政治面貌" readonly is-link @click="showpicker('politics')"
              v-if="baseInfoConfig[10] && baseInfoConfig[10].show" />

            <van-field v-model="formData.basic.IDcard" maxlength="18"
              :required="baseInfoConfig[11] && baseInfoConfig[11].required" label="身份证号" placeholder="请输入身份证号" clearable
              v-if="baseInfoConfig[11] && baseInfoConfig[11].show" />

            <van-field v-model="formData.basic.health" :required="baseInfoConfig[12] && baseInfoConfig[12].required"
              label="健康状况" placeholder="请选择健康状况" readonly is-link @click="showpicker('health')"
              v-if="baseInfoConfig[12] && baseInfoConfig[12].show" />

            <van-field v-model="formData.basic.marital" :required="baseInfoConfig[13] && baseInfoConfig[13].required"
              label="婚姻状况" placeholder="请选择婚姻状况" readonly is-link @click="showpicker('marital')"
              v-if="baseInfoConfig[13] && baseInfoConfig[13].show" />

            <van-field v-model="formData.basic.children"
              :required="baseInfoConfig[14] && baseInfoConfig[14].required && formData.basic.marital === '已婚已育'"
              label="子女情况" placeholder="请选择子女情况" readonly is-link @click="showpicker('children')"
              v-if="baseInfoConfig[14] && baseInfoConfig[14].show" />

            <van-field v-model="formData.basic.higDegree" :required="baseInfoConfig[15] && baseInfoConfig[15].required"
              label="最高学历" placeholder="请选择最高学历" readonly is-link @click="showpicker('higDegree')"
              v-if="baseInfoConfig[15] && baseInfoConfig[15].show" />

            <van-field v-model="formData.basic.jobExp" :required="baseInfoConfig[16] && baseInfoConfig[16].required"
              label="工作年限" placeholder="请选择工作年限" readonly is-link @click="showpicker('jobExp')"
              v-if="baseInfoConfig[16] && baseInfoConfig[16].show" />

            <van-field v-model="formData.basic.bodyHeight" :required="baseInfoConfig[17] && baseInfoConfig[17].required"
              label="身高cm" placeholder="请输入身高cm" clearable v-if="baseInfoConfig[17] && baseInfoConfig[17].show" />

            <van-field v-model="formData.basic.bodyWeight" :required="baseInfoConfig[18] && baseInfoConfig[18].required"
              label="体重kg" placeholder="请输入体重kg" clearable v-if="baseInfoConfig[18] && baseInfoConfig[18].show" />

            <van-field v-model="formData.basic.employment" :required="baseInfoConfig[19] && baseInfoConfig[19].required"
              label="在职状况" placeholder="请选择在职状况" readonly is-link @click="showpicker('employment')"
              v-if="baseInfoConfig[19] && baseInfoConfig[19].show" />

            <van-field v-model="formData.basic.joinDate" :required="baseInfoConfig[20] && baseInfoConfig[20].required"
              label="到岗时间" placeholder="请输入到岗时间" clearable v-if="baseInfoConfig[20] && baseInfoConfig[20].show" />

            <van-field v-model="formData.basic.currSalary" :required="baseInfoConfig[21] && baseInfoConfig[21].required"
              label="目前薪资" placeholder="请输入目前薪资" clearable v-if="baseInfoConfig[21] && baseInfoConfig[21].show" />

            <van-field v-model="formData.basic.expSalary" :required="baseInfoConfig[22] && baseInfoConfig[22].required"
              label="期望薪资" placeholder="请输入期望薪资" clearable v-if="baseInfoConfig[22] && baseInfoConfig[22].show" />

            <van-field v-model="formData.basic.currResidence"
              :required="baseInfoConfig[23] && baseInfoConfig[23].required" label="现居住址" placeholder="请输入现居住址" clearable
              v-if="baseInfoConfig[23] && baseInfoConfig[23].show" />

            <van-field v-model="formData.basic.housType" :required="baseInfoConfig[24] && baseInfoConfig[24].required"
              label="住址性质" placeholder="请输入住址性质" readonly is-link @click="showpicker('housType')"
              v-if="baseInfoConfig[24] && baseInfoConfig[24].show" />

            <van-cell title="求职排序" is-link :value="rankingDisplay || '请设置排序'" @click="showRankingPopup = true"
              class="ranking-cell" />

            <van-field v-model="formData.basic.myself" :required="baseInfoConfig[25] && baseInfoConfig[25].required"
              label="自我介绍" placeholder="请输入自我介绍" type="textarea" rows="4" autosize
              v-if="baseInfoConfig[25] && baseInfoConfig[25].show" />
          </van-form>
        </div>
        <div v-show="currentStep === 2">
          <h3 class="section-title">工作经历 <span class="desc">请按时间倒序填写（最近一份在前）</span></h3>
          <div v-for="(work, index) in formData.workList" :key="'work' + index" class="card-item">
            <van-form>
              <van-field v-model="work.startTime" :required="workConfig[0] && workConfig[0].required" readonly is-link
                label="开始时间" placeholder="请选择开始时间" @click="openWorkDatePicker('start', index)" />
              <van-field v-model="work.endTime" :required="workConfig[0] && workConfig[0].required" readonly is-link
                label="结束时间" placeholder="请选择结束时间" @click="openWorkDatePicker('end', index)" />
              <van-field v-model="work.company" :required="workConfig[1] && workConfig[1].required" label="公司名称"
                placeholder="请输入公司名称" />
              <van-field v-model="work.role" :required="workConfig[2] && workConfig[2].required" label="职位"
                placeholder="请输入您的职位" />
              <van-field v-model="work.resignation" :required="workConfig[3] && workConfig[3].required" label="离职原因"
                placeholder="请输入离职原因" />
              <van-field v-model="work.salary" :required="workConfig[4] && workConfig[4].required" label="收入"
                placeholder="请输入收入" />
            </van-form>
            <!-- 删除按钮放在卡片底部右侧 -->
            <div v-if="formData.workList.length > 1" class="card-footer">
              <van-button plain type="danger" size="small" icon="delete-o" @click="removeWork(index)"
                class="delete-btn">
                删除
              </van-button>
            </div>
          </div>
          <van-button plain type="info" block icon="plus" class="add-btn" @click="addWork">添加工作经历</van-button>
        </div>
        <div v-show="currentStep === 3">
          <h3 class="section-title">教育经历 <span class="desc">请按时间倒序填写（最高学历在前）</span></h3>
          <div v-for="(edu, index) in formData.eduList" :key="'edu' + index" class="card-item">
            <van-form>
              <van-field v-model="edu.startTime" :required="eduConfig[0] && eduConfig[0].required" readonly is-link
                label="开始时间" placeholder="请选择开始时间" @click="openEduDatePicker('start', index)" />
              <van-field v-model="edu.endTime" :required="eduConfig[0] && eduConfig[0].required" readonly is-link
                label="结束时间" placeholder="请选择结束时间" @click="openEduDatePicker('end', index)" />
              <van-field v-model="edu.school" :required="eduConfig[1] && eduConfig[1].required" label="学校名称"
                placeholder="请输入学校名称" />
              <van-field v-model="edu.major" :required="eduConfig[2] && eduConfig[2].required" label="所学专业"
                placeholder="请输入所学专业" />
              <van-field v-model="edu.degree" :required="eduConfig[3] && eduConfig[3].required" readonly is-link
                @click="showpicker('eduDegree', index)" label="学历" placeholder="请选择学历" />
              <van-field v-model="edu.isUnified" :required="eduConfig[4] && eduConfig[4].required" readonly is-link
                @click="showpicker('isUnified', index)" label="是否统招" placeholder="请选择是否统招" />
            </van-form>
            <!-- 删除按钮 -->
            <div v-if="formData.eduList.length > 1" class="card-footer">
              <van-button plain type="danger" size="small" icon="delete-o" @click="removeEdu(index)" class="delete-btn">
                删除
              </van-button>
            </div>
          </div>
          <van-button plain type="info" block icon="plus" class="add-btn" @click="addEdu">添加教育经历</van-button>
        </div>
        <div v-show="currentStep === 4" v-if="familySwitch">
          <h3 class="section-title">家庭信息 </h3>
          <div v-for="(family, index) in formData.familyList" :key="'family' + index" class="card-item">
            <van-form>
              <van-field v-model="family.name" :required="familyConfig[0] && familyConfig[0].required" label="姓名"
                placeholder="请输入姓名" />
              <van-field v-model="family.relation" :required="familyConfig[1] && familyConfig[1].required" label="关系"
                placeholder="请输入关系" />
              <van-field v-model="family.work" :required="familyConfig[2] && familyConfig[2].required" label="工作单位"
                placeholder="请输入工作单位" />
              <van-field v-model="family.role" :required="familyConfig[3] && familyConfig[3].required" label="职务"
                placeholder="请输入职务" />
              <van-field v-model="family.phone" :required="familyConfig[4] && familyConfig[4].required" maxlength="11"
                label="手机号" placeholder="请输入手机号" />
            </van-form>
            <!-- 删除按钮 -->
            <div v-if="formData.familyList.length > 1" class="card-footer">
              <van-button plain type="danger" size="small" icon="delete-o" @click="removeFamily(index)"
                class="delete-btn">
                删除
              </van-button>
            </div>
          </div>
          <van-button plain type="info" block icon="plus" class="add-btn" @click="addFamily">添加家庭信息</van-button>
        </div>
        <div v-show="currentStep === 5" class="confirm-page">
          <h3 class="section-title">诚信声明</h3>
          <div class="summary-card">
            <div class="card-header">
              <van-icon name="contact" />&nbsp;&nbsp;声明信息
            </div>
            <div class="card-body">
              <p v-html="baseInfoConfig[27] && baseInfoConfig[27].desc || ''"></p>
            </div>
          </div>

          <div class="signature-section">
            <h4 class="signature-title">请在此签名确认</h4>
            <div class="signature-canvas-wrapper">
              <canvas ref="signatureCanvas" class="signature-canvas" @touchstart="startSign" @touchmove="sign"
                @touchend="endSign"></canvas>
            </div>
            <div class="signature-actions">
              <van-button plain type="default" size="small" @click="clearSignature">清除签名</van-button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-actions">
        <van-button v-if="currentStep > 1" type="default" @click="goToPrev" class="action-btn half">上一步</van-button>
        <van-button v-if="currentStep < 5" type="info" @click="goToNext" class="action-btn"
          :class="{ half: currentStep > 1 }">下一步</van-button>
        <van-button v-if="currentStep === 5" type="info" block @click="submitForm" class="action-btn">提交</van-button>
      </div>
    </div>

    <!-- 渠道选择器 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker :columns="pickerOptions" show-toolbar cancel-button-text="取消" confirm-button-text="确定"
        @confirm="onChannelConfirm" @cancel="showPicker = false" />
    </van-popup>

    <!-- 出生日期年月选择器 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker type="year-month" :min-date="new Date('1970-01-01')" :max-date="new Date()"
        @confirm="onDateConfirm" @cancel="showDatePicker = false" />
    </van-popup>

    <!-- 教育时间年月选择器 -->
    <van-popup v-model="showEduPicker" position="bottom">
      <van-datetime-picker type="year-month" :value="selectedEduDate" :min-date="new Date('1970-01-01')"
        :max-date="new Date()" @confirm="onEduDateConfirm" @cancel="showEduPicker = false" />
    </van-popup>

    <!-- 工作时间年月选择器 -->
    <van-popup v-model="showWorkPicker" position="bottom">
      <van-datetime-picker type="year-month" :value="selectedWorkDate" :min-date="new Date('1970-01-01')"
        :max-date="new Date()" @confirm="onWorkDateConfirm" @cancel="showWorkPicker = false" />
    </van-popup>

    <!-- 求职排序弹窗 -->
    <van-popup v-model="showRankingPopup" position="bottom" round :style="{ height: '60%' }">
      <div class="ranking-popup">
        <div class="ranking-popup-header">
          <span class="ranking-popup-title">求职排序</span>
          <van-icon name="cross" size="20" @click="showRankingPopup = false" />
        </div>
        <p class="ranking-popup-desc">点击上下箭头调整排序，越靠上表示越重要</p>
        <div class="ranking-list">
          <div v-for="(item, index) in rankingItemsBasic" :key="item.id" class="ranking-item">
            <span class="ranking-order">{{ index + 1 }}</span>
            <span class="ranking-name">{{ item.name }}</span>
            <div class="ranking-arrows">
              <van-icon name="arrow-up" class="ranking-arrow" :class="{ 'ranking-arrow-disabled': index === 0 }"
                @click="moveUpBasic(index)" />
              <van-icon name="arrow-down" class="ranking-arrow"
                :class="{ 'ranking-arrow-disabled': index === rankingItemsBasic.length - 1 }"
                @click="moveDownBasic(index)" />
            </div>
          </div>
        </div>
        <div class="ranking-popup-footer">
          <van-button plain type="default" block @click="resetRanking">重置排序</van-button>
          <van-button type="info" block @click="confirmRanking">确认排序</van-button>
        </div>
      </div>
    </van-popup>

    <div v-if="currentStep === 6" class="page-success">
      <van-icon name="checked" color="#1989fa" size="80" class="success-icon" />
      <h2>提交成功！</h2>
      <p>感谢您的信息填写<br>我们会尽快与您联系</p>

      <div class="success-details">
        <p><van-icon name="clock-o" /> 提交时间: {{ formData.interviewTime }}</p>
        <p><van-icon name="bag-o" /> 应聘职位: {{ formData.basic.interviewJob }}</p>
        <p><van-icon name="manager-o" /> 公司人事: {{ hr }}</p>
        <p><van-icon name="phone-o" /> 人事电话: {{ hrTel }}</p>
      </div>

      <van-button plain type="info" block round @click="goHome()" class="home-btn">
        返回首页
      </van-button>
    </div>
  </div>
</template>

<script>
import { getRegConfig, getcomInfo, getresInfo, setresInfo, setregister } from "@/request/api";
export default {
  created() {
    this.getCom();
  },
  data() {
    return {
      hr: '',
      hrTel: '',
      selectedWorkDate: new Date(), // 工作经历选择的日期
      selectedEduDate: new Date(),  // 教育经历选择的日期
      logoSrc: '',
      comName: '',
      comEngName: '',
      familySwitch: false,
      baseInfoConfig: [],
      workConfig: [],
      eduConfig: [],
      familyConfig: [],
      currentStep: 0, // 0: 签到, 1: 基础, 2: 工作, 3: 教育, 4: 确认, 5: 成功
      loginForm: {
        phone: "",
        agree: false
      },
      currShowType: '',
      currIndex: -1, // 当前操作的列表索引
      showPicker: false, // 控制选择器显示
      pickerOptions: [],
      showDatePicker: false, // 控制日期选择器显示
      showEduPicker: false, // 控制教育时间日期选择器显示
      eduDateType: '', // 教育时间类型：start 或 end
      showWorkPicker: false, // 控制工作时间日期选择器显示
      workDateType: '', // 工作时间类型：start 或 end
      channelOptions: ['BOSS直聘', '智联招聘', '前程无忧', '鱼泡直聘', '58同城', '猎聘网', '脉脉网', '小红书', '抖音', '微信', '猎头', '内推', '其他'], // 渠道选项
      showRankingPopup: false,
      rankingDisplay: '',
      rankingItemsBasic: [
        { id: 1, name: "薪酬", order: 1 },
        { id: 2, name: "职业发展", order: 2 },
        { id: 3, name: "领导", order: 3 },
        { id: 4, name: "氛围", order: 4 },
        { id: 5, name: "公司规模", order: 5 },
        { id: 6, name: "工作环境", order: 6 }
      ],
      formData: {
        signature: "",// 签名
        interviewTime: "",// 面试时间
        ranking: [],// 求职排序
        basic: {
          channel: "",// 渠道
          interviewJob: "",// 面试职位
          name: "",// 姓名
          gender: "",// 性别
          birthDate: "",// 出生日期
          IDcard: "",// 身份证号
          phone: "",// 手机号
          email: "",// 邮箱
          origin: "",// 户籍
          household: "",// 户口
          currResidence: "",// 当前居住地
          housType: "",// 房屋类型
          nation: "",// 民族
          politics: "",// 政治面貌
          marital: "",// 婚姻状况
          children: "",// 子女状况
          health: "",// 健康状况
          higDegree: "",// 最高学历
          employment: "",// 在职状况
          joinDate: "",// 到岗时间
          currSalary: "",// 当前薪资
          expSalary: "",// 期望薪资
          jobExp: "",// 工作经验
          bodyHeight: "",// 身高
          bodyWeight: "",// 体重
          myself: "",// 自我介绍
        },
        workList: [
          { id: '', startTime: "", endTime: "", company: "", role: "", resignation: "", salary: "" }
        ],
        eduList: [
          { id: '', school: "", degree: "", major: "", startTime: "", endTime: "", isUnified: "" }
        ],
        familyList: [
          { id: '', name: "", relation: "", work: "", role: "", phone: "" }
        ]
      }
    };
  },
  methods: {
    goHome() {
      // 提交成功后清除数据
      this.resetFormData();
      this.currentStep = 0;
    },
    resetFormData() {
      this.loginForm = {
        phone: "",
        agree: false
      };
      this.rankingDisplay = '';
      this.rankingItemsBasic = [
        { id: 1, name: "薪酬", order: 1 },
        { id: 2, name: "职业发展", order: 2 },
        { id: 3, name: "领导", order: 3 },
        { id: 4, name: "氛围", order: 4 },
        { id: 5, name: "公司规模", order: 5 },
        { id: 6, name: "工作环境", order: 6 }
      ];
      this.$set(this, 'formData', {
        signature: "",
        interviewTime: "",
        ranking: [],
        basic: {
          channel: "",
          interviewJob: "",
          name: "",
          gender: "",
          birthDate: "",
          IDcard: "",
          phone: "",
          email: "",
          origin: "",
          household: "",
          currResidence: "",
          housType: "",
          nation: "",
          politics: "",
          marital: "",
          children: "",
          health: "",
          higDegree: "",
          employment: "",
          joinDate: "",
          currSalary: "",
          expSalary: "",
          bodyHeight: "",
          bodyWeight: "",
          myself: "",
        },
        workList: [
          { id: '', startTime: "", endTime: "", company: "", role: "", resignation: "", salary: "" }
        ],
        eduList: [
          { id: '', school: "", degree: "", major: "", startTime: "", endTime: "", isUnified: "" }
        ],
        familyList: [
          { id: '', name: "", relation: "", work: "", role: "", phone: "" }
        ]
      });
    },
    async getCom() {
      const { data: res } = await getcomInfo({ comName: this.$route.fullPath });
      if (res.code === 200) {
        this.comEngName = res.data.comEnglishName;
        this.comName = res.data.comName;
        this.logoSrc = require(`@/assets/img/com-logo/${this.comEngName}.png`);
      }
    },
    // 显示选择器并设置选择器选项
    showpicker(currShow, index = -1) {
      this.currShowType = currShow;
      this.currIndex = index; // 保存当前操作的索引
      if (currShow === 'birthDate') {
        this.showDatePicker = true;
        return;
      }
      this.showPicker = true;
      if (currShow === 'channel') {
        this.pickerOptions = this.channelOptions;
      } else if (currShow === 'gender') {
        this.pickerOptions = ['男', '女'];
      } else if (currShow === 'household') {
        this.pickerOptions = ['本地城镇', '本地农村', '外地城镇', '外地农村'];
      } else if (currShow === 'politics') {
        this.pickerOptions = ['群众', '团员', '党员'];
      } else if (currShow === 'marital') {
        this.pickerOptions = ['未婚', '已婚未育', '已婚已育', '离异'];
      } else if (currShow === 'children') {
        this.pickerOptions = ['男宝', '女宝', '一男一女', '二男宝', '二女宝'];
      } else if (currShow === 'health') {
        this.pickerOptions = ['健康', '良好', '一般', '差'];
      } else if (currShow === 'higDegree' || currShow === 'eduDegree') {
        this.pickerOptions = ['初中', '高中', '中专', '大专', '本科', '硕士', '博士'];
      } else if (currShow === 'jobExp') {
        this.pickerOptions = ['1年', '2年', '3年', '4年', '5年', '6年', '7年', '8年', '9年', '10年', '11年', '12年', '12年以上'];
      } else if (currShow === 'housType') {
        this.pickerOptions = ['自住', '合租', '租房'];
      } else if (currShow === 'employment') {
        this.pickerOptions = ['在职', '离职'];
      } else if (currShow === 'isUnified') {
        this.pickerOptions = ['统招', '非统招'];
      }
    },
    // 渠道选择确认后赋值
    onChannelConfirm(value) {
      if (this.currShowType === 'channel') {
        this.formData.basic.channel = value;
      }
      if (this.currShowType === 'gender') {
        this.formData.basic.gender = value;
      }
      if (this.currShowType === 'household') {
        this.formData.basic.household = value;
      }
      if (this.currShowType === 'politics') {
        this.formData.basic.politics = value;
      }
      if (this.currShowType === 'marital') {
        this.formData.basic.marital = value;
      }
      if (this.currShowType === 'children') {
        this.formData.basic.children = value;
      }
      if (this.currShowType === 'health') {
        this.formData.basic.health = value;
      }
      if (this.currShowType === 'higDegree') {
        this.formData.basic.higDegree = value;
      }
      if (this.currShowType === 'eduDegree') {
        this.formData.eduList[this.currIndex].degree = value;
      }
      if (this.currShowType === 'isUnified') {
        this.formData.eduList[this.currIndex].isUnified = value;
      }
      if (this.currShowType === 'jobExp') {
        this.formData.basic.jobExp = value;
      }
      if (this.currShowType === 'housType') {
        this.formData.basic.housType = value;
      }
      if (this.currShowType === 'employment') {
        this.formData.basic.employment = value;
      }
      this.showPicker = false;
    },
    // 年月选择确认
    onDateConfirm(date) {
      this.formData.basic.birthDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      this.showDatePicker = false;
    },
    // 教育时间选择器显示
    openEduDatePicker(type, index) {
      this.eduDateType = type;
      this.currIndex = index;

      // 获取当前字段的值
      const currentValue = this.formData.eduList[index][type === 'start' ? 'startTime' : 'endTime'];

      // 如果有已保存的值且不是"至今"，则将其转换为 Date 对象作为默认值
      if (currentValue && currentValue !== '' && currentValue !== '至今') {
        const [year, month] = currentValue.split('-').map(Number);
        if (year && month) {
          this.selectedEduDate = new Date(year, month - 1); // month - 1 因为 JavaScript 月份从 0 开始
        } else {
          this.selectedEduDate = new Date(); // 默认当前日期
        }
      } else {
        this.selectedEduDate = new Date(); // 默认当前日期
      }

      this.showEduPicker = true;
    },
    // 教育时间年月选择确认
    onEduDateConfirm(date) {
      const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      if (this.eduDateType === 'start') {
        this.formData.eduList[this.currIndex].startTime = dateStr;
      } else {
        this.formData.eduList[this.currIndex].endTime = dateStr;
      }
      this.showEduPicker = false;
    },
    // 工作时间选择器显示
    openWorkDatePicker(type, index) {
      this.workDateType = type;
      this.currIndex = index;

      // 获取当前字段的值
      const currentValue = this.formData.workList[index][type === 'start' ? 'startTime' : 'endTime'];

      // 如果有已保存的值且不是"至今"，则将其转换为 Date 对象作为默认值
      if (currentValue && currentValue !== '' && currentValue !== '至今') {
        const [year, month] = currentValue.split('-').map(Number);
        if (year && month) {
          this.selectedWorkDate = new Date(year, month - 1); // month - 1 因为 JavaScript 月份从 0 开始
        } else {
          this.selectedWorkDate = new Date(); // 默认当前日期
        }
      } else {
        this.selectedWorkDate = new Date(); // 默认当前日期
      }

      this.showWorkPicker = true;
    },
    // 工作时间年月选择确认
    onWorkDateConfirm(date) {
      const dateStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      if (this.workDateType === 'start') {
        this.formData.workList[this.currIndex].startTime = dateStr;
      } else {
        this.formData.workList[this.currIndex].endTime = dateStr;
      }
      this.showWorkPicker = false;
    },
    async getRegConfig() {
      const { data: res } = await getRegConfig({ comName: this.$route.path });
      this.baseInfoConfig = res.data.baseInfo;
      this.workConfig = res.data.workInfo;
      this.eduConfig = res.data.education;
      this.familyConfig = res.data.homeInfo;
      this.familySwitch = res.data.homeConfig === 1 ? true : false;
    },
    async goToNext() {
      const rex = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[1589]))\d{8}$/

      // 步骤0：签到页验证
      if (this.currentStep === 0) {
        if (!this.loginForm.phone || this.loginForm.phone.length !== 11 || !rex.test(this.loginForm.phone)) {
          this.$message.warning('请输入正确的11位手机号')
          return;
        }
        if (!this.loginForm.agree) {
          this.$toast('请先阅读并同意隐私政策');
          return;
        }
        const { data: res } = await getresInfo({ comName: this.$route.path, phone: this.loginForm.phone });
        if (res.code === 200) {
          this.getRegConfig();

          this.formData.basic.id = res.data.basicInfo.id;
          this.formData.basic.resumeID = res.data.basicInfo.resumeID;
          this.formData.basic.user_id = res.data.basicInfo.user_id
          this.formData.basic.com_id = res.data.basicInfo.com_id;
          this.formData.basic.name = res.data.basicInfo.name;
          this.formData.basic.phone = res.data.basicInfo.phone;
          this.formData.basic.email = res.data.basicInfo.email;
          this.formData.basic.jobExp = String(new Date().getFullYear() - res.data.basicInfo.jobExp) + '年';
          this.formData.basic.interviewJob = res.data.basicInfo.interviewJob;
          this.formData.basic.gender = res.data.basicInfo.gender === 1 ? '男' : '女';
          // 将数据格式转换并赋值给 formData.workList
          if (res.data.workExperience.length > 0) {
            this.formData.workList = res.data.workExperience.map(item => ({
              id: item.id,
              startTime: `${item.start_year}-${item.start_month}`,
              endTime: item.end_year === 9999 ? `${new Date().getFullYear()}-${String(new Date().getMonth() + 1)}` : `${item.end_year}-${item.end_month}`, // 如果年份是9999则显示当前年月
              company: item.companyName,
              role: item.work_jobName,
              resignation: "", // 离职原因，可以从数据中补充或留空
              salary: "",      // 收入，可以从数据中补充或留空
            }));
          }
          if (res.data.eduExperience.length > 0) {
            this.formData.eduList = res.data.eduExperience.map(item => ({
              id: item.id,
              startTime: `${item.start_year}-${item.start_month}`,
              endTime: item.end_year === 9999 ? `${new Date().getFullYear()}-${String(new Date().getMonth() + 1)}` : `${item.end_year}-${item.end_month}`, // 如果年份是9999则显示至今
              school: item.edu_name,
              major: item.edu_major,
              degree: item.edu_degree === '2' ? '大专' : item.edu_degree === '3' ? '本科' : item.edu_degree === '4' ? '硕士' : item.edu_degree === '5' ? '博士' : '其他',
              isUnified: item.edu_nature === 1 ? '统招' : '非统招',
            }))
          }
        } else {
          this.$toast(res.message);
          return;
        }
      }

      // 步骤1：基础信息页验证
      if (this.currentStep === 1) {
        const basicFields = ['channel', 'interviewJob', 'name', 'gender', 'phone', 'email', 'birthDate', 'nation', 'origin', 'household', 'politics', 'IDcard', 'health', 'marital', 'children', 'higDegree', 'jobExp', 'employment', 'joinDate', 'currSalary', 'expSalary', 'currResidence', 'housType', 'myself'];
        for (let i = 0; i < basicFields.length; i++) {
          if (this.baseInfoConfig[i] && this.baseInfoConfig[i].required && this.baseInfoConfig[i].show) {
            // 子女情况字段：只有当婚姻状况为"已婚已育"时才必填
            if (basicFields[i] === 'children' && this.formData.basic.marital !== '已婚已育') {
              continue;
            }
            const fieldValue = this.formData.basic[basicFields[i]];
            if (!fieldValue || fieldValue.trim() === '') {
              this.$toast('请完善信息后再下一步！');
              return;
            }
          }
        }
      }

      // 步骤2：工作经历页验证
      if (this.currentStep === 2) {
        if (this.formData.workList.length === 0) {
          this.$toast('请至少添加一条工作经历');
          return;
        }
        for (const work of this.formData.workList) {
          const workFields = ['startTime', 'endTime', 'company', 'role', 'resignation', 'salary'];
          for (let i = 0; i < workFields.length; i++) {
            // startTime 和 endTime 共用 workConfig[0]
            const configIndex = i === 0 || i === 1 ? 0 : i - 1;
            if (this.workConfig[configIndex] && this.workConfig[configIndex].required) {
              const fieldValue = work[workFields[i]];
              if (!fieldValue || fieldValue.trim() === '') {
                this.$toast('请完善信息后再下一步！');
                return;
              }
            }
          }
        }
      }

      // 步骤3：教育经历页验证
      if (this.currentStep === 3) {
        if (this.formData.eduList.length === 0) {
          this.$toast('请至少添加一条教育经历');
          return;
        }
        for (const edu of this.formData.eduList) {
          const eduFields = ['startTime', 'endTime', 'school', 'major', 'degree', 'isUnified'];
          for (let i = 0; i < eduFields.length; i++) {
            const configIndex = i === 0 || i === 1 ? 0 : i - 1;
            if (this.eduConfig[configIndex] && this.eduConfig[configIndex].required) {
              const fieldValue = edu[eduFields[i]];
              if (!fieldValue || fieldValue.trim() === '') {
                this.$toast('请完善信息后再下一步！');
                return;
              }
            }
          }
        }
      }

      // 步骤4：家庭信息页验证（如果启用）
      if (this.currentStep === 4 && this.familySwitch) {
        if (this.formData.familyList.length === 0) {
          this.$toast('请至少添加一条家庭信息');
          return;
        }
        for (const family of this.formData.familyList) {
          const familyFields = ['name', 'relation', 'work', 'role', 'phone'];
          for (let i = 0; i < familyFields.length; i++) {
            if (this.familyConfig[i] && this.familyConfig[i].required) {
              const fieldValue = family[familyFields[i]];
              if (!fieldValue || fieldValue.trim() === '') {
                this.$toast('请完善信息后再下一步！');
                return;
              }
            }
          }
        }
      }

      // 正常跳转
      if (this.familySwitch === false && this.currentStep === 3) {
        this.currentStep = 5;
      } else {
        this.currentStep++;
      }
      window.scrollTo(0, 0);
    },
    goToPrev() {
      if (this.familySwitch === false && this.currentStep === 5) {
        this.currentStep = 3;
      } else {
        this.currentStep--;
      }
      window.scrollTo(0, 0);
    },
    addWork() {
      this.formData.workList.push({ startTime: "", endTime: "", company: "", role: "", resignation: "", salary: "", referee: "" });
    },
    removeWork(index) {
      if (this.formData.workList.length > 1) {
        this.formData.workList.splice(index, 1);
      }
    },
    addEdu() {
      this.formData.eduList.push({ school: "", degree: "", major: "", time: "", isUnified: "" });
    },
    removeEdu(index) {
      if (this.formData.eduList.length > 1) {
        this.formData.eduList.splice(index, 1);
      }
    },
    addFamily() {
      this.formData.familyList.push({ name: "", relation: "", work: "", role: "", phone: "" });
    },
    removeFamily(index) {
      if (this.formData.familyList.length > 1) {
        this.formData.familyList.splice(index, 1);
      }
    },
    async submitForm() {
      if (!this.formData.signature) {
        this.$toast('请签名后再提交！');
        return;
      }
      this.formData.interviewTime = new Date().toLocaleString();
      this.$toast.loading({ message: '提交中...', forbidClick: true });

      this.formData.ranking = this.formData.ranking.map(item => item.name).join('->');

      const { data: res } = await setresInfo(this.formData);
      if (res.code === 200) {
        const { data: res2 } = await setregister({ resumeID: this.formData.basic.resumeID, comID: this.formData.basic.com_id, userID: this.formData.basic.user_id, name: this.formData.basic.name });
        if (res2.code === 200) {
          this.hr = res2.data.name;
          this.hrTel = res2.data.phone;
          this.$toast.success('签到成功！');
        } else {
          this.$toast.fail('签到失败！');
        }
      } else {
        this.$toast.fail('提交失败！');
      }

      setTimeout(() => {
        this.$toast.clear();
        this.currentStep = 6; // 进入成功页
      }, 1000);
    },
    // 初始化画布
    initCanvas() {
      const canvas = this.$refs.signatureCanvas;
      if (!canvas || this.canvasInited) return;

      const ctx = canvas.getContext('2d');
      const rect = canvas.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      // 保存画布尺寸
      this.canvasWidth = rect.width;
      this.canvasHeight = rect.height;

      canvas.width = this.canvasWidth * dpr;
      canvas.height = this.canvasHeight * dpr;
      canvas.style.width = this.canvasWidth + 'px';
      canvas.style.height = this.canvasHeight + 'px';
      ctx.scale(dpr, dpr);

      ctx.lineWidth = 2.5;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = '#1d1d1f';

      this.canvasInited = true;
    },
    // 签名相关方法
    startSign(e) {
      e.preventDefault();
      e.stopPropagation();

      this.initCanvas();

      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const touch = e.touches[0];
      const rect = canvas.getBoundingClientRect();

      // 记录初始偏移，后续使用相对坐标
      this.startOffsetX = rect.left;
      this.startOffsetY = rect.top;

      ctx.beginPath();

      this.lastX = touch.clientX - this.startOffsetX;
      this.lastY = touch.clientY - this.startOffsetY;
      ctx.moveTo(this.lastX, this.lastY);
    },
    sign(e) {
      e.preventDefault();
      e.stopPropagation();

      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const touch = e.touches[0];

      // 使用初始偏移计算，避免滚动导致错位
      const currentX = touch.clientX - this.startOffsetX;
      const currentY = touch.clientY - this.startOffsetY;

      // 边界检查
      if (currentX < 0 || currentX > this.canvasWidth ||
        currentY < 0 || currentY > this.canvasHeight) {
        return;
      }

      // 确保有有效的起点
      if (this.lastX === undefined || this.lastY === undefined) {
        this.lastX = currentX;
        this.lastY = currentY;
        ctx.beginPath();
        ctx.moveTo(this.lastX, this.lastY);
        return;
      }

      // 直接连线，保持流畅
      ctx.lineTo(currentX, currentY);
      ctx.stroke();

      this.lastX = currentX;
      this.lastY = currentY;
    },
    endSign(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      ctx.closePath();
      // 将画布内容转换为 Base64 格式并保存到 formData
      const signatureData = canvas.toDataURL('image/png');
      this.formData.signature = signatureData;
      this.lastX = undefined;
      this.lastY = undefined;
      this.startOffsetX = undefined;
      this.startOffsetY = undefined;
    },
    clearSignature() {
      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      const dpr = window.devicePixelRatio || 1;
      ctx.clearRect(0, 0, this.canvasWidth * dpr, this.canvasHeight * dpr);
    },
    moveUpBasic(index) {
      if (index <= 0) return;
      const temp = this.rankingItemsBasic[index];
      this.rankingItemsBasic.splice(index, 1);
      this.rankingItemsBasic.splice(index - 1, 0, temp);
    },
    moveDownBasic(index) {
      if (index >= this.rankingItemsBasic.length - 1) return;
      const temp = this.rankingItemsBasic[index];
      this.rankingItemsBasic.splice(index, 1);
      this.rankingItemsBasic.splice(index + 1, 0, temp);
    },
    confirmRanking() {
      this.showRankingPopup = false;
      this.rankingDisplay = this.rankingItemsBasic.map(item => item.name).join(' > ');
      this.formData.ranking = this.rankingItemsBasic.map((item, index) => ({
        id: item.id,
        name: item.name,
        order: index + 1
      }));
    },
    resetRanking() {
      this.rankingItemsBasic = [
        { id: 1, name: "薪酬", order: 1 },
        { id: 2, name: "职业发展", order: 2 },
        { id: 3, name: "领导", order: 3 },
        { id: 4, name: "氛围", order: 4 },
        { id: 5, name: "公司规模", order: 5 },
        { id: 6, name: "工作环境", order: 6 }
      ];
      this.rankingDisplay = '';
      this.formData.ranking = [];
    },
  },

};
</script>

<style lang="scss" scoped>
/* 核心配色变量 */
$primary-color: #3b82f6;
$primary-light: #dbeafe;
$primary-dark: #2563eb;
$bg-color: #f1f5f9;
$bg-card: #ffffff;
$text-main: #1e293b;
$text-secondary: #64748b;
$text-light: #94a3b8;
$border-color: #e2e8f0;
$success-color: #10b981;
$warning-color: #f59e0b;
$shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
$shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
$shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
$shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
$radius-sm: 8px;
$radius-md: 12px;
$radius-lg: 16px;
$radius-xl: 24px;

* {
  box-sizing: border-box;
}

.interview-app {
  min-height: 100vh;
  background-color: $bg-color;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino SansGB", "Microsoft YaHei", Arial, sans-serif;
  color: $text-main;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 0. 签到页样式 */
.page-login {
  background: linear-gradient(180deg, $primary-light 0%, $bg-color 40%);
  min-height: 100vh;
  padding: 20px;

  .login-header {
    margin-top: 30px;
    animation: fadeInDown 0.6s ease-out;

    .logo {
      position: absolute;
      top: 6px;
      right: 6px;
      width: 97px;
      height: 35px;
      margin: 0;
      object-fit: contain;
    }

    h2 {
      font-size: 36px;
      font-weight: 800;
      margin: 40px 0 25px;
      color: $text-main;
      background: linear-gradient(135deg, $text-main 0%, $primary-color 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      user-select: none;
    }

    p {
      color: $text-secondary;
      font-size: 15px;
      margin-top: 16px;
      user-select: none;
      line-height: 1.5;
    }
  }

  .login-box {
    background: $bg-card;
    border-radius: $radius-xl;
    padding: 32px;
    margin-top: 30px;
    box-shadow: $shadow-xl;
    animation: fadeInUp 0.6s ease-out 0.2s both;
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:active {
      transform: scale(0.98);
      box-shadow: $shadow-lg;
    }

    h3 {
      margin: 0 0 8px;
      font-size: 20px;
      font-weight: 600;
    }

    .subtitle {
      font-size: 12px;
      color: $text-light;
      margin-bottom: 20px;
    }

    .phone-input {
      border: 1px solid #ebedf0;
      border-radius: 8px;
      margin-bottom: 24px;

      &:focus {
        border-color: $primary-color;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }



    .submit-btn {
      margin-bottom: 24px;
      height: 48px;
      font-size: 16px;
      font-weight: 600;
      border-radius: $radius-md;
      background: linear-gradient(135deg, $primary-color 0%, $primary-dark 100%);
      box-shadow: 0 4px 14px rgba(59, 130, 246, 0.4);
      transition: all 0.3s ease;

      &:active {
        transform: translateY(2px);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
      }
    }



    .policy {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: $text-secondary;
      gap: 6px;

      a {
        color: $primary-color;
        text-decoration: none;
        transition: color 0.2s ease;
      }

      &:hover {
        color: $primary-dark;
      }
    }
  }

  .foot {
    color: $text-light;
    user-select: none;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
    font-size: 12px;
  }
}

/* 1-4. 步骤条与表单页通用样式 */
.page-steps {
  padding-bottom: 80px;
  /* 留出底部按钮空间 */

  .custom-steps {
    background: transparent;
    padding: 20px;

    ::v-deep .van-step__circle-container {
      background-color: transparent;
    }
  }

  .form-container {
    background: #fff;
    border-radius: 12px 12px 0 0;
    padding: 20px;
    min-height: calc(100vh - 150px);
  }

  .section-title {
    font-size: 18px;
    color: $text-main;
    margin-bottom: 20px;
    border-left: 4px solid $primary-color;
    padding-left: 8px;

    .desc {
      font-size: 12px;
      color: $text-light;
      font-weight: normal;
      margin-left: 8px;
    }
  }

  .card-item {
    background: $bg-color;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    overflow: hidden;
  }

  .card-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 4px;
    border-top: 1px solid #f0f0f0;
  }

  .delete-btn {
    font-size: 12px;
    padding: 4px 12px;
  }

  .add-btn {
    border-radius: 8px;
    border-style: dashed;
    margin: 20px 0;
  }

  /* 确认信息页 */
  .confirm-page {
    .summary-card {
      background: $bg-color;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 16px;

      .card-header {
        display: flex;
        align-items: center;
        font-weight: bold;
        color: $primary-color;
        border-bottom: 1px solid #ebedf0;
        padding-bottom: 8px;
        margin-bottom: 8px;

        a {
          color: $text-light;
          font-weight: normal;
          font-size: 14px;
        }
      }

      .card-body p {
        margin: 6px 0;
        font-size: 14px;
        color: $text-main;
        line-height: 1.5;
      }
    }

    .confirm-check {
      margin-top: 24px;
      font-size: 14px;
    }

    .signature-section {
      margin-top: 20px;

      .signature-title {
        font-size: 16px;
        font-weight: 600;
        color: $text-main;
        margin-bottom: 12px;
      }

      .signature-canvas-wrapper {
        background: #fff;
        border: 2px dashed $border-color;
        border-radius: $radius-md;
        padding: 10px;
        margin-bottom: 12px;

        .signature-canvas {
          width: 100%;
          height: 160px;
          border-radius: $radius-sm;
        }
      }

      .signature-actions {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 16px;
      }
    }
  }

  /* 底部悬浮按钮栏 */
  .footer-actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 12px 20px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    gap: 12px;
    z-index: 2000;

    .action-btn {
      flex: 1;
      border-radius: 20px;

      &.half {
        flex: 0.5;
      }
    }
  }
}

/* 5. 成功页样式 */
.page-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;

  .success-icon {
    margin-bottom: 24px;
    box-shadow: 0 10px 20px rgba(25, 137, 250, 0.2);
    border-radius: 50%;
  }

  h2 {
    margin: 0 0 12px;
    color: $text-main;
  }

  p {
    text-align: center;
    color: $text-light;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 40px;
  }

  .success-details {
    width: 100%;
    background: $bg-color;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 40px;

    p {
      text-align: left;
      margin: 12px 0;
      color: $text-main;
      display: flex;
      align-items: center;
      gap: 8px;

      .van-icon {
        color: $text-light;
      }
    }
  }

  .home-btn {
    width: 80%;
  }
}

.ranking-cell {
  margin-top: 8px;

  ::v-deep .van-cell__title {
    flex: none;
    min-width: 100px;
  }

  ::v-deep .van-cell__value {
    color: gray;
    font-size: 12px;
    white-space: normal;
    word-break: keep-all;
    text-align: left;
  }
}

.ranking-popup {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 16px;

  .ranking-popup-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0 8px;
    border-bottom: 1px solid $border-color;
  }

  .ranking-popup-title {
    font-size: 18px;
    font-weight: 700;
    color: $text-main;
  }

  .ranking-popup-desc {
    font-size: 12px;
    color: $text-light;
    margin: 10px 0 6px;
  }

  .ranking-list {
    flex: 1;
    overflow-y: auto;
    padding: 8px 0;
  }

  .ranking-item {
    display: flex;
    align-items: center;
    padding: 14px 12px;
    margin: 6px 0;
    background: $bg-color;
    border-radius: $radius-md;
    transition: transform 0.15s ease, box-shadow 0.15s ease;


  }

  .ranking-order {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: $primary-color;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .ranking-name {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
    color: $text-main;
  }

  .ranking-arrows {
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex-shrink: 0;
  }

  .ranking-arrow {
    font-size: 16px;
    color: $primary-color;
    padding: 4px 6px;
    border-radius: 4px;
    background: $primary-light;
    transition: opacity 0.15s ease;

    &:active {
      background: $primary-color;
      color: #fff;
    }

    &.ranking-arrow-disabled {
      opacity: 0.25;
      pointer-events: none;
    }
  }

  .ranking-popup-footer {
    display: flex;
    gap: 12px;
    padding: 16px 0;
    border-top: 1px solid $border-color;
  }
}
</style>